import createIcon from '../../createIcon';

/**
 * @component @name EmojiEvents
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNUgxN1YzSDdWNUg1QzMuOSA1IDMgNS45IDMgN1Y4QzMgMTAuNTUgNC45MiAxMi42MyA3LjM5IDEyLjk0QzguMDIgMTQuNDQgOS4zNyAxNS41NyAxMSAxNS45VjE5SDdWMjFIMTdWMTlIMTNWMTUuOUMxNC42MyAxNS41NyAxNS45OCAxNC40NCAxNi42MSAxMi45NEMxOS4wOCAxMi42MyAyMSAxMC41NSAyMSA4VjdDMjEgNS45IDIwLjEgNSAxOSA1Wk01IDhWN0g3VjEwLjgyQzUuODQgMTAuNCA1IDkuMyA1IDhaTTE5IDhDMTkgOS4zIDE4LjE2IDEwLjQgMTcgMTAuODJWN0gxOVY4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EmojiEvents = createIcon('EmojiEvents', [
  [
    'path',
    {
      d: 'M19 5H17V3H7V5H5C3.9 5 3 5.9 3 7V8C3 10.55 4.92 12.63 7.39 12.94C8.02 14.44 9.37 15.57 11 15.9V19H7V21H17V19H13V15.9C14.63 15.57 15.98 14.44 16.61 12.94C19.08 12.63 21 10.55 21 8V7C21 5.9 20.1 5 19 5ZM5 8V7H7V10.82C5.84 10.4 5 9.3 5 8ZM19 8C19 9.3 18.16 10.4 17 10.82V7H19V8Z',
      key: 'r8c1ir',
    },
  ],
]);

export default EmojiEvents;
